import { EntitySelectorsFactory } from '@ngrx/data';
import { createSelector } from '@ngrx/store';
import { Workspace } from '../entities';

export const workspaceSelectors = new EntitySelectorsFactory().create<Workspace>('Workspace');

export const selectCurrentWorkspace = (id: string) =>
  createSelector(workspaceSelectors.selectEntityMap, (data) => {
    const workspace = data[id];
    const cacheBuster = new Date().getTime().toString();
    const logo_url = workspace?.logo_url ? workspace?.logo_url.concat('?', cacheBuster) : workspace?.logo_url;
    const icon_url = workspace?.icon_url ? workspace?.icon_url.concat('?', cacheBuster) : workspace?.icon_url;
    return { ...workspace, logo_url, icon_url };
  });

export const selectLogo = (id: string) =>
  createSelector(workspaceSelectors.selectEntityMap, (data) => data[id]?.logo_url || '');

export const selectIcon = (id: string) =>
  createSelector(workspaceSelectors.selectEntityMap, (data) => data[id]?.icon_url || '');

export const selectIsDarkMode = (id: string) =>
  createSelector(workspaceSelectors.selectEntityMap, (data) => data[id]?.theme_dark);

export const selectCustomColor = (id: string) =>
  createSelector(workspaceSelectors.selectEntityMap, (data) => data[id]?.custom_color || '');
